import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faFilter, faImage, faGraduationCap, faLayerGroup, faTachometerAlt, faBook, faDolly, faClipboardCheck, faArrowRight, faTruck, faClipboardList, faMapLocationDot, faUserGraduate, faPencil, faLocationDot, faChartBar, faCogs, faSignOut, faUserFriends, faMobileScreen, faTicket, faTaxi, faCoins, faUsers, faFile, faCashRegister, faIceCream, faCreditCard, faKey } from '@fortawesome/free-solid-svg-icons' // <-- import styles to be used

const BotonAdmin = ({ nombre, onClick, sub, active, roll, verPara }) => {

	const EncuentraIcono = icon => {

		switch (icon) {
			case 'Sistema Pos': return faCashRegister
			case 'Escritorio': return faTachometerAlt
			case 'Cursos': return faGraduationCap
			case 'Temas': return faBook
			case 'Usuarios': return faUserFriends
			case 'Configuración': return faCogs
			case 'Actividades': return faClipboardCheck
			case 'Certificados': return faUserGraduate
			case 'Cerrar Sesión': return faSignOut
			case 'Productos': return faPencil
			case 'Ubicaciones': return faLocationDot
			case 'Zonas de Envio': return faMapLocationDot
			case 'Cargas de Envio': return faTruck
			case 'Reglas de Envio': return faDolly
			case 'Pedidos': return faClipboardList
			case 'Creador Paginas': return faFile
			case 'Medios de Pago': return faCreditCard
			case 'Informes': return faChartBar
			case 'Cierres de Caja': return faKey
			case 'Publicidad': return faImage
			case 'Cupones': return faTicket
			case 'Niveles': return faLayerGroup
			case 'Historial de Inventario': return faDolly
			case 'Items App' : return faMobileScreen
			case 'CRM' : return faFilter
			default: return faArrowRight
		}
	}


	return (

		<button
			// className={sub ? "sub-item" : "item"}
			style={roll === verPara || roll === 'Admin' ? null : null}
			className={active === nombre ? sub ? "sub-item active" : "item active" : sub ? "sub-item" : "item"}
			onClick={onClick(nombre)}>
			<FontAwesomeIcon icon={EncuentraIcono(nombre)} size="1x" />
			{' ' + nombre}
		</button>
	)
}



export default BotonAdmin